import { render, staticRenderFns } from "./AuthSendPasswordResetEmail.vue?vue&type=template&id=d8fe8206&"
import script from "./AuthSendPasswordResetEmail.vue?vue&type=script&lang=js&"
export * from "./AuthSendPasswordResetEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VForm,VTextField})
